import { initializeApp } from "firebase/app";


import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";


import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCbLgP3pWVcn9erN0y-HsHpCWfXUICDyxk",
    authDomain: "quickbill-7aa73.firebaseapp.com",
    projectId: "quickbill-7aa73",
    storageBucket: "quickbill-7aa73.firebasestorage.app",
    messagingSenderId: "361033199664", 
    appId: "1:361033199664:web:f39f4151f4cdff65f97df5" 
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

export const db = getFirestore(app);

// Enable Firestore offline disk caching for robust salesman offline operation
enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
        console.warn("Firestore offline persistence failed (multiple tabs open)");
    } else if (err.code === 'unimplemented') {
        console.warn("Firestore offline persistence not supported by this browser");
    } else {
        console.warn("Firestore offline persistence error: ", err.message);
    }
});

export const storage = getStorage(app); 




